import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { __rest } from "tslib";
import React from 'react';
import Dropdown from '../Dropdown/Dropdown';
var DropdownMenu = /*#__PURE__*/function (_React$Component) {
  function DropdownMenu(props) {
    var _this;
    _classCallCheck(this, DropdownMenu);
    _this = _callSuper(this, DropdownMenu, [props]);
    _this.toggleDropdown = function (event) {
      var opened = _this.state.opened;
      event.preventDefault();
      _this.setState({
        opened: !opened
      }, function () {
        _this.props.onClick({
          opened: !opened
        });
      });
    };
    _this.handleClickOutside = function () {
      if (_this.state.opened) {
        _this.setState({
          opened: false
        }, function () {
          _this.props.onClick({
            opened: false
          });
        });
      }
    };
    _this.state = {
      opened: props.opened
    };
    return _this;
  }
  _inherits(DropdownMenu, _React$Component);
  return _createClass(DropdownMenu, [{
    key: "render",
    value: function render() {
      var actionable = /*#__PURE__*/React.cloneElement(this.props.actionable, {
        onClick: this.toggleDropdown
      });
      var _a = this.props,
        opened = _a.opened,
        onClick = _a.onClick,
        props = __rest(_a, ["opened", "onClick"]);
      return /*#__PURE__*/React.createElement(Dropdown, Object.assign({}, props, {
        actionable: actionable,
        onClickOutside: this.handleClickOutside,
        opened: this.state.opened
      }));
    }
  }]);
}(React.Component);
DropdownMenu.defaultProps = {
  opened: false,
  'data-aut-id': '',
  onClick: function onClick() {}
};
export default DropdownMenu;